import { Component, OnInit, Input, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { MemberQuery, RewardsWalletItem, RewardsWalletQuery, RewardsWalletService, WalletGroupItem } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit, AfterViewInit, OnDestroy {
  walletItems$: Observable<WalletGroupItem[]>;
  isList: boolean = true;
  walletItemsUnclaimed$: Observable<RewardsWalletItem[]>;
  @Input() walletItems: RewardsWalletItem[];
  screenType = ScreenType;
  population = Populations;

  @ViewChild('walletContainer', { static: false }) walletContainerRef: ElementRef;
  private draggableInstance: any;

  constructor(
    private rewardsWalletQuery: RewardsWalletQuery,
    private rewardsWalletService: RewardsWalletService,
    private memberQuery: MemberQuery
  ) {
    gsap.registerPlugin(Draggable);
  }

  async ngOnInit() {
    firstValueFrom(this.rewardsWalletService.fetchWalletItems());
    this.walletItems$ = this.rewardsWalletQuery.selectGroupedUnredeemedWalletItems();
  }

  ngAfterViewInit() {
    if (this.walletContainerRef) {
      const walletContainerElement = this.walletContainerRef.nativeElement.closest('fgb-wallet-page') as HTMLElement;
      const walletContainerHeight = walletContainerElement.clientHeight;
      let barcodeHeight = 0;
      if (this.memberQuery.getPopulationName() === this.population.Kids) {
        barcodeHeight = 270;
      } else {
        barcodeHeight = 390;
      }
      this.draggableInstance = Draggable.create(this.walletContainerRef.nativeElement, {
        type: 'y',
        edgeResistance: 1,
        bounds: { minY: -barcodeHeight, maxY: 0 },
        inertia: true,
        handle: '.grab-point',
        onDrag: () => {
          const y = this.draggableInstance.y;
          walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + y}px`;
        },
        onDragEnd: () => {
          const y = this.draggableInstance.y;
          let snapY = 0;
          // Snap to nearest
          snapY = Math.abs(y + barcodeHeight) < Math.abs(y) ? -barcodeHeight : 0;
          gsap.to(this.walletContainerRef.nativeElement, {
            y: snapY,
            duration: 0.3,
            onUpdate: () => {
              const currentY = gsap.getProperty(this.walletContainerRef.nativeElement, 'y') as number;
              walletContainerElement.style.height = `${walletContainerHeight + barcodeHeight + currentY}px`;
            },
          });
        },
      })[0];
    }
  }

  ngOnDestroy() {
    if (this.draggableInstance) {
      this.draggableInstance.kill();
    }
  }
}
